import { IconProps } from "../../types/utils";

const LoadingIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 57}
    height={dimension || 57}
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="29.5" cy="16.5003" r="3.5" fill="#6DA588" />
    <circle cx="3.5" cy="16.5" r="3.5" fill="#6DA588" />
    <g opacity="0.4">
      <circle
        cx="16.5001"
        cy="3.50018"
        r="3.5"
        transform="rotate(-90 16.5001 3.50018)"
        fill="#94D6B4"
      />
      <circle
        cx="16.4998"
        cy="29.5002"
        r="3.5"
        transform="rotate(-90 16.4998 29.5002)"
        fill="#94D6B4"
      />
    </g>
  </svg>
);

export default LoadingIcon;
